var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sftp-status'),_c('Providers',{attrs:{"providers":_vm.entity.providers,"show-settings":true,"show-cloud-watch-url":true,"show-latest-cad-data-link":true,"show-failed-files":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }